import { __read, __spreadArray } from "tslib";
import logger from '../lib/logger';
import { uuid } from '../helpers/misc';
if (!window.skland)
    window.skland = {};
if (!window.skland.callbackMap)
    window.skland.callbackMap = new Map();
var ABaseNative = /** @class */ (function () {
    function ABaseNative() {
        var _this = this;
        this.callbackIdMap = {
            SKPage_lifeCycle: uuid(8),
            SKMessage_register: ABaseNative.SKMessage_callbackId,
            SKMessage_unregister: ABaseNative.SKMessage_callbackId,
        };
        this.voidCallbackId = uuid(8);
        this.setCallback = function (callback, callbackId) {
            if (callbackId === void 0) { callbackId = uuid(8); }
            _this.callbackMap.set(callbackId, callback);
            return callbackId;
        };
        this.callback = function (callbackId) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (callbackId === _this.voidCallbackId)
                return;
            if (!_this.callbackMap.has(callbackId)) {
                logger.log("callbackId[".concat(callbackId, "] is not exist"), 'error');
                return;
            }
            var callbackHandler = _this.callbackMap.get(callbackId);
            callbackHandler === null || callbackHandler === void 0 ? void 0 : callbackHandler.apply(void 0, __spreadArray([], __read(args), false));
            var isExist = Object.values(_this.callbackIdMap).some(function (valId) {
                return valId === callbackId;
            });
            if (!isExist)
                _this.callbackMap.delete(callbackId);
        };
        this.postMessage = function (target, method, params, callback) {
            try {
                var callbackId = _this.voidCallbackId;
                if (callback) {
                    var apiName = "".concat(target, "_").concat(method);
                    callbackId = _this.callbackIdMap[apiName] || uuid(8);
                    _this.callbackMap.set(callbackId, callback);
                }
                var callHandler = _this.getCallHandler(target, method);
                callHandler(callbackId, params);
            }
            catch (error) {
                callback && callback(error, null);
            }
        };
        if (!window.skland.callBack) {
            window.skland.callBack = this.callback;
        }
    }
    Object.defineProperty(ABaseNative.prototype, "callbackMap", {
        get: function () {
            return window.skland.callbackMap;
        },
        enumerable: false,
        configurable: true
    });
    ABaseNative.SKMessage_callbackId = uuid(8);
    return ABaseNative;
}());
export default ABaseNative;
